export class MISC {
    static LOCAL_SERVER = process.env?.REACT_APP_LOCAL_SERVER
        ? process.env.REACT_APP_LOCAL_SERVER
        : "";

    static isInt = (value) => {
        return /^-?\d+$/.test(value);
    }    
    
    static isBoolean(val) {
        return val === false || val === true;
     }

    static apiRequest = async (type, payload) => {
		const response = await fetch(`${this.LOCAL_SERVER}/api/${type}.php`, {
			method: "POST",
			headers: {
				"Content-Type" : "application/json"
			},
            credentials: 'include',
            withCredentials: true,
			body: JSON.stringify(payload)
        })
        .then(response => response.json());
		
        return response;
    }

    static apiHasError = (response) => {
        return !response?.success || !response?.data;
    }

    static apiGetErrorStr = (response) => {
        let newError = "";

        if (!response?.success) {
            newError = response?.message && response.message?.length > 0
                ? response.message
                : "";
            
            newError = new Error(newError);

            if (response?.data && Object.keys(response.data)?.length > 0) {
                Object.assign(newError, response.data);
            }

            return newError;
        }
    }

    static apiSendError = (baseStr, errorStr, commonMethods, headerStr) => {
        let failStr;
        if (baseStr && baseStr?.length > 0) {
            failStr = baseStr;
            failStr = errorStr && errorStr?.length > 0
                ? `${baseStr}: ${errorStr}.`
                : `${baseStr}.`;
        } else {
            failStr = errorStr && errorStr?.length > 0
                ? `${errorStr}.`
                : 'Unknown error';
        }

        const dialogObj = {
            body: failStr
        };

        if (headerStr) {
            dialogObj["header"] = headerStr;
        }

        if (commonMethods) {
            commonMethods.createDialog(dialogObj);
        }

        return console.error(failStr);
    }

    static fetchJson = async (filename) => {
        try {
            return fetch(filename)
                .then(response => {
                    if(!response.ok) {
                        throw "Failed to load";
                    }
                    return response.json();
                });
        } catch (e) {
            console.error(`Error fetching ${filename}: `, e);
        }
    }
}